import * as React from "react";
import { RouteComponentProps } from "react-router";
import {
	Form,
	Button,
	Header,
	Message,
	Grid,
	Segment
} from "semantic-ui-react";
import { LoggedInRedirect } from "../../helpers/WithLoggedIn";
import { auth, firebaseDB } from "../../firebase";

interface IProps extends RouteComponentProps<{}> {}

interface IState {
	email: string;
	password: string;
	passwordConfirm: string;
	error: string;
	name: string;
	isLoading: boolean;
}

class RegistrationPage extends React.Component<IProps, IState> {
	state = {
		email: "",
		password: "",
		passwordConfirm: "",
		error: "",
		name: "",
		isLoading: false
	};

	handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({
			[evt.currentTarget.name as any]: evt.currentTarget.value
		} as any);
	};

	handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const { email, password, passwordConfirm } = this.state;

		this.setState({ isLoading: true });

		auth
			.createUserWithEmailAndPassword(email, password)
			.then(authUser => {
				firebaseDB.ref("users/" + auth.currentUser.uid).set({
					name: this.state.name,
					lastUpdated: null,
					answers: []
				});

				// this.props.history.push("/");
			})
			.catch(error => {
				this.setState({
					error: error.message,
					isLoading: false
				});
			});
	};

	render() {
		const { email, password, passwordConfirm, error } = this.state;
		const isInvalid =
			password !== passwordConfirm ||
			password === "" ||
			email === "" ||
			email === "";
		return (
			<Grid
				textAlign="center"
				style={{ height: "100%" }}
				verticalAlign="middle"
			>
				<Grid.Column style={{ maxWidth: 450 }}>
					<Segment stacked>
						<Form onSubmit={this.handleSubmit}>
							<Header as="h2"> Sign Up </Header>
							{this.state.error && (
								<Message negative>{this.state.error}</Message>
							)}
							<Form.Input
								placeholder="Name"
								onChange={this.handleChange}
								value={this.state.name}
								name="name"
								icon="user"
								iconPosition="left"
							/>
							<Form.Input
								placeholder="Email"
								icon="mail"
								iconPosition="left"
								value={this.state.email}
								onChange={this.handleChange}
								name="email"
								type="text"
							/>
							<Form.Input
								placeholder="Password"
								icon="lock"
								iconPosition="left"
								value={this.state.password}
								onChange={this.handleChange}
								name="password"
								type="password"
							/>
							<Form.Input
								placeholder="Confirm Password"
								icon="lock"
								iconPosition="left"
								value={this.state.passwordConfirm}
								onChange={this.handleChange}
								name="passwordConfirm"
								type="password"
							/>
							<Button
								fluid
								type="submit"
								disabled={isInvalid}
								loading={this.state.isLoading}
							>
								Submit
							</Button>
						</Form>
					</Segment>
				</Grid.Column>
			</Grid>
		);
	}
}

export default (RegistrationPage);



// WEBPACK FOOTER //
// ./src/pages/RegistrationPage/RegistrationPage.tsx